import {defer as observableDefer } from 'rxjs';
import {take, refCount, publishReplay} from 'rxjs/operators';
import { Injectable } from "@angular/core";
import { ApiService } from './api';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class InfoService {
    private cachedS3Bucket: any;

    constructor(private http: HttpClient, private api: ApiService) {}

    getS3Bucket = () => {
        if (!this.cachedS3Bucket) {
            this.cachedS3Bucket = observableDefer(() => this.api.get('/ws/info/s3Bucket')).pipe(publishReplay(1, 60000), refCount(), take(1));
        }

        return this.cachedS3Bucket;
    };

    getS3Creds(filename, type) {
        return this.api.post('/ws/info/s3Creds',{ filename, type });
    }

    uploadFile(file, details) {
        return this.http.post(details.url, this.api.formDataFor({
            key: details.fields.key,
            AWSAccessKeyId: details.fields.AWSAccessKeyId,
            acl: details.fields.acl,
            policy: details.fields.policy,
            signature: details.fields.signature,
            'Content-Type': details.fields['Content-Type'] || 'application/octet-stream',
            'success_action_status': details.fields.success_action_status,
            file: file
        }), { responseType: 'text' });
    }
}